import React, { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { api } from "../../../api/apiService";
import { toast } from "react-toastify";
import { Link } from "react-router-dom";

const ForgotPassword = () => {
  const schema = yup.object().shape({
    email: yup
      .string()
      .email("Invalid email format")
      .required("Email is required"),
  });

  const {
    register,
    handleSubmit,
    formState: { errors, isValid },
  } = useForm({
    resolver: yupResolver(schema),
    mode: "onChange",
  });

  const [isLoading, setIsLoading] = useState(false);
  const [successMessage, setSuccessMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");
  const [formErrors, setFormErrors] = useState({});

  const submitForm = async (data) => {
    clearMessages();
    setIsLoading(true);

    try {
      const response = await api.post("/forgot-password", {
        email: data.email,
      });
      setIsLoading(false);

      if (response.data.status) {
        // Success
        setSuccessMessage(response.data.message);
        toast.success("Password reset email sent successfully");
      } else {
        // Error
        setErrorMessage(response.data.message);
        if (response.data.errors) {
          setFormErrors(response.data.errors);
        }
      }
    } catch (error) {
      setIsLoading(false);
      if (error && error.data) {
        toast.error(error.data.message || "An error occurred");
      } else {
        toast.error("An unexpected error occurred. Please try again.");
      }
    }
  };

  const clearMessages = () => {
    setSuccessMessage("");
    setErrorMessage("");
    setFormErrors({});
  };

  return (
    <div className="container-fluid login d-flex align-items-center justify-content-center">
      <div className="card shadow-lg border-0 rounded-4">
        <div className="card-body p-4">
          <div className="text-center mb-4">
            <img
              src="assets/img/Logo.svg"
              alt="Logo"
              className="mb-4"
              width={120}
            />
            <p className="text-muted small">Recover your password</p>
          </div>

          <form
            onSubmit={handleSubmit(submitForm)}
            className="needs-validation"
          >
            <div className="mb-3">
              <label htmlFor="email" className="form-label">
                Email
              </label>
              <div className="input-group">
                <span className="input-group-text bg-light">
                  <i className="bi bi-envelope"></i>
                </span>
                <input
                  type="email"
                  id="email"
                  className={`form-control ${errors.email ? "is-invalid" : ""}`}
                  placeholder="name@example.com"
                  {...register("email")}
                />
                {errors.email && (
                  <div className="invalid-feedback">{errors.email.message}</div>
                )}
              </div>
              {formErrors.email && (
                <div className="text-danger text-sm mt-1">
                  {formErrors.email[0]}
                </div>
              )}
            </div>
            {successMessage && (
              <div className="alert alert-success">{successMessage}</div>
            )}
            {errorMessage && (
              <div className="alert alert-danger">{errorMessage}</div>
            )}

            <div className="d-grid mb-3">
              <button
                type="submit"
                className="btn btn-primary"
                disabled={isLoading || !isValid}
              >
                {isLoading ? "Sending Reset Email..." : "Send Reset Email"}
              </button>
            </div>

            <div className="text-center">
              <Link
                to="/login"
                className="text-decoration-none small text-primary"
              >
                Back to Login
              </Link>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
